import styled from '@emotion/styled';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

//* * Buttons
export const BoxIcon = styled(Icon)`
	background-color: var(--background-3);
	color: var(--color-white);
	border-radius: 50%;
	padding: var(--padding-2);
	margin-right: var(--margin-1);
`;

export const ImportActionButtonStyled = styled(Button)`
	justify-content: start;
	&.borderless {
		border-color: var(--border-color);
	}
	&.large {
		padding: 1.5rem 2rem 1.5rem 1.1rem;
	}

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		&.large {
			padding: 2rem;
		}
	}
`;

const ButtonContainer = ({ children, ...rest }) => <div {...rest}>{children}</div>;

export const StyledButtonContainer = styled(ButtonContainer)`
	display: flex;
	justify-content: flex-start;
	row-gap: 1rem;

	margin-top: var(--margin-1);
`;
//* * Buttons
